import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Avatar,
  Typography,
  IconButton,
  Button,
  Chip,
  TablePagination,
  styled,
  tableCellClasses,
  Box,
  TextField,
  Backdrop,
  CircularProgress,
  Collapse,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Grid,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  useMediaQuery,
} from "@mui/material";
import { encryptId } from "../../Components/CryptoComponent";
import {
  Edit,
  Delete,
  ExpandMore,
  Visibility,
  FilterList,
  Add,
  Search,
  RestartAlt,
  KeyboardArrowDown,
  KeyboardArrowUp,
  WorkOutline,
  Work,
} from "@mui/icons-material";
import WorkIcon from "@mui/icons-material/Work";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { useLocation, useNavigate } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import SelectInput from "../../Components/InputComponents/SelectInput";
import { errorNotify } from "../../Components/ToastComponent/ToastNotification";

import CloseIcon from "@mui/icons-material/Close";
import TextInput from "../../Components/InputComponents/TextInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useStaffLayout } from "../../Components/Context/CandidateLayoutContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: `#2C5F8E`,
    color: `#FFFFFF`,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap",
    fontFamily: "Geist, sans-serif",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Geist, sans-serif",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: `#EBF2FF`,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#D6E6F2",
    boxShadow: "0px 0px 5px 0px grey",
  },
}));

const ListCandidate = ({ isAdmin }) => {
  const { privilegeData } = useStaffLayout();

  function hasCandidateAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasCandidateEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasCandidateViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isCandidate = subModule.subModuleName
        .toLowerCase()
        .includes("candidate");
      if (!isCandidate) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  const navigate = useNavigate();
  const location = useLocation();

  const [CandidateData, setCandidateData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageCount, setPageCount] = useState("");
  const [loaderOpen, setLoaderOpen] = useState(true);

  const [filterValue, setFilterValue] = useState(null);

  const [open, setOpen] = useState(false);
  const [selectedJobIndex, setselectedJobIndex] = useState("");
  const [filterData, setFilterData] = useState({
    name: "",
    passport_no: "",
    branch: "",
    job: "",
    deployed_or_cancelled: "",
    offer_status: "",
    jobStatus: "",
    profession: "",
    CountryID: "",
    start_date: "",
    end_date: "",
    recruitmentProcedure: null,
    recruitmentStages: null,
    recruitmentSubProcedures: null,
    recruitmentProcedureFields: null,
  });

  // useEffect(() => {
  //   if (open != true) {
  //     setFilterData({
  //       ...filterData,
  //       profession: "",
  //       CountryID: "",

  //       jobStatus: "",
  //       offer_status: "",
  //       start_date: "",
  //       end_date: "",
  //       recruitmentProcedure: null,
  //       recruitmentStages: null,
  //       recruitmentSubProcedures: null,
  //       recruitmentProcedureFields: null,
  //     });
  //   }
  // }, [open]);

  const [jobList, setJobList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [professionList, setProfessionList] = useState([]);
  const [jobStatusList, setjobStatusList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [offerStatusList, setOfferStatusList] = useState([]);
  const [recruitmentProcedureList, setRecruitmentProcedureList] = useState([]);
  const [recruitmentStageslist, setRecruitmentStageslist] = useState([]);
  const [recrSubProcList, setRecrSubProcList] = useState([]);
  const [recrProcFieldsList, setRecrProcFieldsList] = useState([]);

  const [expandedIds, setExpandedIds] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApplyFilters = () => {
    setPage(0);

    const trimmedFilters = {
      name: filterData?.name?.trim() || "",
      passport_no: filterData?.passport_no?.trim() || "",
      profession_id: filterData?.profession || "",
      CountryID: filterData?.CountryID || "",
      deployed_or_cancelled: filterData?.deployed_or_cancelled,
      offer_status: filterData?.offer_status,
      job_id: filterData?.job,
      jobStatus: filterData?.jobStatus,
      start_date: filterData?.start_date,
      end_date: filterData?.end_date,
      status_id: "",
      branch_id: filterData?.branch?.trim?.() || filterData?.branch || "",
      filter_RP_Id: filterData?.recruitmentProcedure || null,
      filter_RPS_Id: filterData?.recruitmentStages || null,
      filter_RSP_Id: filterData?.recruitmentSubProcedures || null,
      filter_RPF_Value: filterValue,
    };

    axiosAPI
      ?.post(`/Candidate/${rowsPerPage}/${page + 1}/listNew`, trimmedFilters)
      .then((res) => {
        setPageCount(res?.data?.data?.total_count);
        setCandidateData(res?.data?.data?.data);
        setLoaderOpen(false);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
    // navigate("/Candidates", { replace: true }); // removes the old route state
  };

  const handleResetFilterData = () => {
    const resetFilters = {
      name: "",
      passport_no: "",
      profession: "",
      CountryID: "",
      deployed_or_cancelled: "",
      offer_status: "",
      job: "",
      jobStatus: "",
      start_date: "",
      end_date: "",
      branch: "",
      recruitmentProcedure: null,
      recruitmentStages: null,
      recruitmentSubProcedures: null,
      recruitmentProcedureFields: null,
    };

    setFilterData(resetFilters);
    getData(resetFilters);

    navigate("/Candidates", { replace: true }); // removes the old route state
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    let updatedData = { ...filterData, [name]: value };

    // Cascading reset logic
    if (name === "recruitmentProcedure") {
      updatedData.recruitmentStages = null;
      updatedData.recruitmentSubProcedures = null;
      updatedData.recruitmentProcedureFields = null;
    }

    if (name === "recruitmentStages") {
      updatedData.recruitmentSubProcedures = null;
      updatedData.recruitmentProcedureFields = null;
    }

    if (name === "recruitmentSubProcedures") {
      updatedData.recruitmentProcedureFields = null;
    }

    setFilterData(updatedData);
  };

  const [selectedProfileTab, setSelectedProfileTab] = useState(0);

  const paginationState = {
    pagination: { page, rowsPerPage },
    filterData: filterData,
    open: open,
    selectedJobIndex: selectedJobIndex,
    selectedProfileTab: selectedProfileTab,
  };

  const navigatetoCandidateAdd = () => {
    navigate(`/Candidates/Add`, { state: paginationState });
  };

  const navigatetoCandidateEdit = (id) => {
    const encrypted = encodeURIComponent(encryptId(id?.CI_Id));
    navigate(`/Candidates/Edit/${encrypted}`, { state: paginationState });
  };

  const nativatetoViewCandidate = (c) => {
    const encrypted = encodeURIComponent(encryptId(c?.CI_Id));
    navigate(`/Candidates/View/${encrypted}`, {
      state: { ...paginationState, fromRoute: "CandList" },
    });
  };

  const parseValidValues = (rawValues) => {
    if (Array.isArray(rawValues)) return rawValues;
    if (typeof rawValues === "string") {
      try {
        const parsed = JSON.parse(rawValues);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const renderField = (item) => {
    switch (item?.RPF_Type) {
      case "ShortText":
      case "LongText":
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Search Recruitment Procedure Field
            </Typography>
            <TextInput
              key={item?.RPF_Id}
              variant="outlined"
              fullWidth
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
          </Grid>
        );

      case "Number":
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Search Recruitment Procedure Field
            </Typography>
            <TextInput
              key={item?.RPF_Id}
              type="text"
              allowOnlyNumbers={true}
              variant="outlined"
              fullWidth
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
          </Grid>
        );

      case "Date":
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Search Recruitment Procedure Field
            </Typography>
            <TextInput
              key={item?.RPF_Id}
              variant="outlined"
              fullWidth
              type="date"
              multiline={item?.RPF_Type == "LongText"}
              rows={item?.RPF_Type == "LongText" ? 4 : 1}
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
          </Grid>
        );

      case "Time":
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Search Recruitment Procedure Field
            </Typography>
            <TextInput
              key={item?.RPF_Id}
              variant="outlined"
              fullWidth
              type="time"
              multiline={item?.RPF_Type === "LongText"}
              rows={item?.RPF_Type === "LongText" ? 4 : 1}
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
          </Grid>
        );

      case "Radio":
      case "Checkbox":
      case "Dropdown":
        const dropdownOptions = parseValidValues(item?.RPF_ValidValues);
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Search Recruitment Procedure Field
            </Typography>
            <SelectInput
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              options={dropdownOptions.map((opt) => ({
                label: opt,
                value: opt,
              }))}
            />
          </Grid>
        );

      default:
        return null;
    }
  };

  const getData = (filters = filterData) => {
    const trimmedFilters = {
      name: filters?.name,
      passport_no: filters?.passport_no,
      profession_id: filters?.profession,
      job_id: filters?.job,
      CountryID: filters?.CountryID,
      jobStatus: filters?.jobStatus,
      deployed_or_cancelled:
        location?.state?.isDeployed == "deployed"
          ? "deployed"
          : filters?.deployed_or_cancelled,
      offer_status: filters?.offer_status,
      start_date: filters?.start_date,
      end_date: filters?.end_date,
      status_id: "",
      branch_id: "",
      filter_RP_Id: filters?.recruitmentProcedure,
      filter_RPS_Id: filters?.recruitmentStages,
      filter_RSP_Id: filters?.recruitmentSubProcedures,
      filter_RPF_Value: filters?.recruitmentProcedureFields,
    };

    axiosAPI
      ?.post(`/Candidate/${rowsPerPage}/${page + 1}/listNew`, trimmedFilters)
      .then((res) => {
        setPageCount(res?.data?.data?.total_count);
        setCandidateData(res?.data?.data?.data);
        setLoaderOpen(false);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  const getProfession = async () => {
    try {
      const res = await axiosAPI.get(`/Profession/active/list`);
      setProfessionList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getBranches = async () => {
    try {
      const res = await axiosAPI.get(`/Branch/active/list`);
      setBranchList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getCountries = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentCountry/list`);
      setCountryList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getRecruitmentProcedurelist = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentProcedure/list`);
      setRecruitmentProcedureList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getRecruitmentStageslist = async () => {
    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedure/recruitmentstages`,
        {
          procedureID: filterData?.recruitmentProcedure || null,
        }
      );
      setRecruitmentStageslist(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getrecrSubProcList = async () => {
    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedure/recruitmentSubProcedures`,
        {
          subprocedureID: filterData?.recruitmentStages,
        }
      );
      setRecrSubProcList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getrecrProcFieldsList = async () => {
    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedure/recruitmentProcedureFields`,
        {
          StageID: filterData?.recruitmentStages,
          subprocedureID: filterData?.recruitmentSubProcedures
            ? filterData?.recruitmentSubProcedures
            : null,
        }
      );

      setRecrProcFieldsList(
        res?.data?.data?.filter((a) => {
          return a?.RPF_Type != "Attachment";
        }) || []
      );
    } catch (err) {
      console.error(err);
    }
  };

  const getJobs = async () => {
    try {
      const res = await axiosAPI.get(`/Job/list`);
      setJobList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getJobStatus = async () => {
    try {
      const res = await axiosAPI.get(`JobApplicationStatus/list`);
      setjobStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const GetOfferStatusList = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/offerStatuslist`);
      setOfferStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getProfession();
    getBranches();
    getJobs();
    getCountries();
    getJobStatus();
    GetOfferStatusList();
    getRecruitmentProcedurelist();
  }, [page, rowsPerPage]);

  useEffect(() => {
    getRecruitmentStageslist();
    getrecrSubProcList();

    if (filterData?.recruitmentStages || filterData?.recruitmentSubProcedures) {
      getrecrProcFieldsList();
    } else {
      setRecrProcFieldsList([]);
    }

    setFilterData({ ...filterData, recruitmentProcedureFields: null });
  }, [
    filterData?.recruitmentProcedure,
    filterData?.recruitmentStages,
    filterData?.recruitmentSubProcedures,
  ]);

  useEffect(() => {
    setFilterValue("");
  }, [filterData?.recruitmentProcedureFields]);

  useEffect(() => {
    if (location?.state?.isDeployed == "deployed") {
      setFilterData({ ...filterData, deployed_or_cancelled: "deployed" });
    }

    if (location?.state?.pagination) {
      setPage(location.state.pagination.page || 0);
      setRowsPerPage(location.state.pagination.rowsPerPage || 25);
    }

    if (location?.state?.open) {
      setOpen(location?.state?.open);
    }

    if (location?.state?.selectedJobIndex) {
      setselectedJobIndex(location?.state?.selectedJobIndex);
    }

    if (location?.state?.expandedIds) {
      setExpandedIds(location?.state?.expandedIds);
    }

    if (location?.state?.selectedProfileTab) {
      setSelectedProfileTab(location?.state?.selectedProfileTab);
    }

    if (location?.state?.filterData) {
      setFilterData(location.state.filterData);
      getData(location?.state?.filterData); // fetch with restored filters
    } else {
      getData();
    }
  }, [location?.state, page, rowsPerPage]);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Candidate Management
        </Typography>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            ml: "auto",
          }}
        >
          {hasCandidateAddprivilege(privilegeData) && (
            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{ background: "#E75E1F" }}
              onClick={navigatetoCandidateAdd}
              disabled={!hasCandidateAddprivilege(privilegeData)}
            >
              Add
            </Button>
          )}
        </Box>
      </Box>

      {/* Filters */}
      <Box sx={{ maxWidth: "100%", mb: 2 }}>
        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Name
            </Typography>
            <TextField
              placeholder="Name"
              variant="outlined"
              size="small"
              value={filterData?.name}
              onChange={(e) =>
                setFilterData((prev) => ({ ...prev, name: e.target.value }))
              }
              fullWidth
            />
          </Grid>

          {/* Passport Number */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Passport Number
            </Typography>
            <TextField
              placeholder="Passport Number"
              variant="outlined"
              size="small"
              value={filterData?.passport_no}
              onChange={(e) =>
                setFilterData((prev) => ({
                  ...prev,
                  passport_no: e.target.value,
                }))
              }
              fullWidth
            />
          </Grid>

          {/* Branch */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Branch{" "}
            </Typography>
            <SelectInput
              value={filterData?.branch}
              name="branch"
              onChange={handleFilterChange}
              options={branchList?.map((item) => ({
                value: item?.BL_Id,
                label: item?.BL_Name,
              }))}
              placeholder="Select Branch"
              customStyle={{ width: "100%" }}
            />
          </Grid>

          {/* Job */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Job
            </Typography>
            <SelectInput
              value={filterData.job}
              name="job"
              onChange={handleFilterChange}
              options={jobList?.map((item) => ({
                value: item?.JD_Id,
                label: `${item?.JD_Title} (${item?.JD_JobId})`,
              }))}
              placeholder="Select a Job"
            />
          </Grid>

          {/* Deployed Or Cancelled */}
          <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Deployed Or Cancelled
            </Typography>
            <SelectInput
              value={filterData.deployed_or_cancelled}
              name="deployed_or_cancelled"
              onChange={handleFilterChange}
              options={[
                { value: `deployed`, label: `Deployed` },
                { value: `cancelled`, label: `Cancelled` },
              ]}
              placeholder="Select"
            />
          </Grid>

          {open && (
            <>
              {/*  Offer Letter Status */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Offer Letter Status
                </Typography>

                <SelectInput
                  value={filterData.offer_status}
                  name="offer_status"
                  onChange={handleFilterChange}
                  options={offerStatusList?.map((item) => ({
                    value: item?.JOS_Id,
                    label: item?.JOS_Name,
                  }))}
                  placeholder="Select Offer Letter Status"
                />
              </Grid>

              {/* Job Status */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Interview Status
                </Typography>
                <SelectInput
                  value={filterData.jobStatus}
                  name="jobStatus"
                  onChange={handleFilterChange}
                  options={jobStatusList?.map((item) => ({
                    value: item?.JASL_Id,
                    label: item?.JASL_Name,
                  }))}
                  placeholder="Select Interview Status"
                />
              </Grid>

              {/* Profession */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Profession
                </Typography>
                <SelectInput
                  value={filterData?.profession}
                  name="profession"
                  onChange={handleFilterChange}
                  options={professionList?.map((item) => ({
                    value: item?.PI_Id,
                    label: item?.PI_Name,
                  }))}
                  placeholder="Select Recruitment Profession"
                  customStyle={{ width: "100%" }}
                />
              </Grid>

              {/*  Recruitment Country */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Country
                </Typography>
                <SelectInput
                  value={filterData?.CountryID}
                  name="CountryID"
                  onChange={handleFilterChange}
                  options={countryList?.map((item) => ({
                    value: item?.RC_Id,
                    label: item?.RC_CountryName,
                  }))}
                  placeholder="Select Recruitment Country"
                  customStyle={{ width: "100%" }}
                />
              </Grid>

              {/* Recruitment Procedure */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Procedure
                </Typography>
                <SelectInput
                  value={filterData?.recruitmentProcedure || ""}
                  name="recruitmentProcedure"
                  onChange={handleFilterChange}
                  options={recruitmentProcedureList?.map((item) => ({
                    value: item?.RP_Id,
                    label: item?.RP_Name,
                  }))}
                  placeholder="Select Recruitment Procedure"
                  customStyle={{ width: "100%" }}
                />
              </Grid>

              {/* Recruitment Stage */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Stage
                </Typography>
                <SelectInput
                  value={filterData?.recruitmentStages || ""}
                  name="recruitmentStages"
                  onChange={handleFilterChange}
                  options={recruitmentStageslist?.map((item) => ({
                    value: item?.RPS_Id,
                    label: item?.RPS_Name,
                  }))}
                  placeholder="Select Recruitment Stage"
                  customStyle={{ width: "100%" }}
                  isDisabled={!filterData?.recruitmentProcedure}
                />
              </Grid>

              {/* Sub Procedure */}

              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Sub Procedure
                </Typography>
                <SelectInput
                  value={filterData?.recruitmentSubProcedures || ""}
                  name="recruitmentSubProcedures"
                  onChange={handleFilterChange}
                  options={recrSubProcList?.map((item) => ({
                    value: item?.RSP_Id,
                    label: item?.RSP_Name,
                  }))}
                  placeholder="Select Recruitment Sub Process"
                  customStyle={{ width: "100%" }}
                  isDisabled={
                    !filterData?.recruitmentStages ||
                    recrSubProcList?.length < 1
                  }
                />
              </Grid>
              {/* Recruitment Field */}
              <Grid item xs={12} sm={6} md={4} lg={4} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Recruitment Procedure Fields
                </Typography>
                <SelectInput
                  value={filterData?.recruitmentProcedureFields || ""}
                  name="recruitmentProcedureFields"
                  onChange={handleFilterChange}
                  options={recrProcFieldsList?.map((item) => ({
                    value: item,
                    label: item?.RPF_Name,
                  }))}
                  placeholder="Select Recruitment Field"
                  customStyle={{ width: "100%" }}
                  isDisabled={
                    !filterData?.recruitmentSubProcedures &&
                    !filterData?.recruitmentStages
                  }
                />
              </Grid>

              <>{renderField(filterData?.recruitmentProcedureFields)}</>
            </>
          )}
        </Grid>
      </Box>

      {/* Buttons */}
      <Box
        sx={{
          width: "100%", // Full width
          display: "flex",
          justifyContent: "flex-end", // Align buttons to the right
          alignItems: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<Search />}
            onClick={handleApplyFilters}
            sx={{
              textTransform: "capitalize",
              color: "white",
              background: "#006CB8",
            }}
          >
            Search
          </Button>

          <Button
            variant="outlined"
            startIcon={<RestartAlt />}
            onClick={handleResetFilterData}
            sx={{ textTransform: "capitalize" }}
          >
            Reset
          </Button>

          <Button
            variant="outlined"
            startIcon={<FilterList />}
            onClick={() => {
              setOpen(!open);
              handleResetFilterData();
            }}
            sx={{ textTransform: "capitalize" }}
          >
            {open ? "Less" : "More"} Filters
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          borderRadius: "10px",
          overflowX: "auto",
          width: "100%",
          maxWidth: "100vw",
          margin: "auto",
        }}
      >
        {/* Table */}
        <TableContainer
          sx={{
            border: "1px solid transparent",
            borderRadius: "10px",
            maxWidth: "100vw",
            overflowX: "auto",
            margin: "auto",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ width: "50px" }}>#</StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Passport</StyledTableCell>
                <StyledTableCell>Profession</StyledTableCell>
                <StyledTableCell>Branch</StyledTableCell>
                <StyledTableCell align="center">Jobs</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>

                {(hasCandidateViewprivilege(privilegeData) ||
                  hasCandidateEditprivilege(privilegeData)) && (
                  <StyledTableCell align="center" sx={{ width: "150px" }}>
                    {" "}
                    Actions{" "}
                  </StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {loaderOpen ? (
                Array.from({ length: 7 }).map((_, idx) => (
                  <TableRow key={idx}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <StyledTableCell key={index}>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={40}
                        />
                      </StyledTableCell>
                    ))}
                  </TableRow>
                ))
              ) : CandidateData && CandidateData?.length > 0 ? (
                CandidateData.map((c, index) => (
                  <StyledTableRow key={c.id}>
                    <StyledTableCell>
                      {index + 1 + page * rowsPerPage}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Avatar
                          src={`${process.env.REACT_APP_BASE_URL}/${c?.CI_Photo}`}
                          sx={{
                            width: 55,
                            height: 55,
                            mr: 2,
                            border: "1px solid lightgrey",
                            transition:
                              "transform 0.5s ease, box-shadow 0.3s ease",
                            "&:hover": {
                              transform: hasCandidateViewprivilege(privilegeData)?"scale(1.3)":`scale(1)`,
                              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                              cursor:hasCandidateViewprivilege(privilegeData)?"pointer":''
                            },
                          }}
                          onClick={() => {
                            if (hasCandidateViewprivilege(privilegeData)) {
                              nativatetoViewCandidate(c);
                            }
                          }}
                        />

                        <Typography variant="body2">
                          {c?.CI_Name} {c?.CI_Alias ? `(${c?.CI_Alias})` : ""}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>{c?.CI_PassportNo}</StyledTableCell>
                    <StyledTableCell>{c?.CI_Profession}</StyledTableCell>
                    <StyledTableCell>{c?.JD_Branch}</StyledTableCell>
                    <StyledTableCell align="center">
                     
                      {c?.job_applications?.length
                        ? c.job_applications?.length
                        : "-"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={c?.CI_Status}
                        color={c?.CI_Status === "Active" ? "success" : "error"}
                        sx={{
                          fontSize: { xs: "10px", sm: "12px" },
                          width: "80px",
                          fontFamily: "Geist, sans-serif",
                          fontWeight: "600",
                        }}
                      />
                    </StyledTableCell>
                    {(hasCandidateViewprivilege(privilegeData) ||
                      hasCandidateEditprivilege(privilegeData)) && (
                      <StyledTableCell align="center">
                        {hasCandidateViewprivilege(privilegeData) && (
                          <IconButton
                            color="primary"
                            onClick={() => nativatetoViewCandidate(c)}
                            disabled={!hasCandidateViewprivilege(privilegeData)}
                          >
                            <Visibility />
                          </IconButton>
                        )}
                        {hasCandidateEditprivilege(privilegeData) && (
                          <IconButton
                            color="warning"
                            disabled={!hasCandidateEditprivilege(privilegeData)}
                            onClick={() => {
                              navigatetoCandidateEdit(c);
                            }}
                          >
                            <Edit />
                          </IconButton>
                        )}
                      </StyledTableCell>
                    )}
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={9} align="center">
                    <Typography
                      variant="body2"
                      sx={{
                        py: 2,
                        fontSize: "20px",
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      No data available
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={pageCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100]}
        sx={{
          // General font size for the pagination root
          fontSize: { xs: "12px", sm: "14px" },
          // Specific font size for the "Rows per page" label
          "& .MuiTablePagination-selectLabel": {
            fontSize: { xs: "12px", sm: "14px" },
            fontFamily: "Geist, sans-serif", // Optional
          },
        }}
      />
    </Paper>
  );
};

export default ListCandidate;
